import React, { useEffect, useState } from 'react';
import social2 from '../../../../assets/shapes_svg/output/social2.svg';
import { getHighlight } from '../../../../apis/Ambition';
import { useRef } from 'react';
import { PRINT_WIDTH } from '..';
import { fontReport } from '../../../../apis/util';

export const OurWorkplace = () => {
  const [text1, setText1] = useState();
  const [text2, setText2] = useState();
  const [text3, setText3] = useState();
  const [text4, setText4] = useState();
  const [text5, setText5] = useState();
  const [text6, setText6] = useState();
  const [text7, setText7] = useState();
  const [text8, setText8] = useState();

  const [question1, setQuestion1] = useState();
  const [question2, setQuestion2] = useState();
  const [question3, setQuestion3] = useState();
  const [question4, setQuestion4] = useState();
  const [question5, setQuestion5] = useState();
  const [question6, setQuestion6] = useState();
  const [question7, setQuestion7] = useState();
  const [question8, setQuestion8] = useState();

  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = () => {
    getHighlight({ key: "trainingsupport", setValue: setText1 });
    getHighlight({ key: "retention", setValue: setText2 });
    getHighlight({ key: "internalrotation", setValue: setText3 });
    getHighlight({ key: "turnover", setValue: setText4 });
    getHighlight({ key: "sickleave", setValue: setText5 });
    getHighlight({ key: "sickleavestats", setValue: setText6 });
    getHighlight({ key: "enhancingstrategy", setValue: setText7 });
    getHighlight({ key: "socialextracurricular", setValue: setText8 });

    getHighlight({ key: "trainingsupport_question", setValue: setQuestion1 });
    getHighlight({ key: "retention_question", setValue: setQuestion2 });
    getHighlight({ key: "internalrotation_question", setValue: setQuestion3 });
    getHighlight({ key: "turnover_question", setValue: setQuestion4 });
    getHighlight({ key: "sickleave_question", setValue: setQuestion5 });
    getHighlight({ key: "sickleavestats_question", setValue: setQuestion6 });
    getHighlight({ key: "enhancingstrategy_question", setValue: setQuestion7 });
    getHighlight({ key: "socialextracurricular_question", setValue: setQuestion8 });
  };
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="ourenvironmentalaim" ref={ref}>
      <div className="ourenvironmentalaim__title">
        <h4 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.7/PRINT_WIDTH,"rem") }}>Our Workplace</h4>
        <img src={social2} alt="" />
      </div>
      <div className="environmentalaim__body ">
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.4/PRINT_WIDTH,"rem") }}>{question1 + "\n" + text1 +
          "\n\n" +
          question2 + "\n" + text2 +
          "\n\n" +
          question3 + "\n" + text3 +
          "\n\n" +
          question4 + "\n" + text4 +
          "\n\n" +
          question5 + "\n" + text5 +
          "\n\n" +
          question6 + "\n" + text6 +
          "\n\n" +
          question7 + "\n" + text7 +
          "\n\n" +
          question8 + "\n" + text8}</h5>
      </div>
    </div>
  );
};
